<script setup lang="ts">
import { CheckoutFlowStep, useCheckoutFlow } from '@/composables/useCheckoutFlow';
import { useWarehouseInfo } from '@/composables/useWarehouseInfo';

const checkoutFlow = useCheckoutFlow();

const { warehouseData } = useWarehouseInfo();

const handleStartCheckout = () => {
  checkoutFlow.setNextStep(CheckoutFlowStep.ValidationPage);
};
</script>

<template>
  <div class="d-flex flex-column gap-6 px-4 my-auto">
    <h1 class="d-flex flex-column gap-2">
      <span class="welcome">Welcome to</span>
      <span class="title globalseo-exclude">{{ warehouseData?.name }}</span>
    </h1>
    <p class="instructions">Tap below to begin your check-out process.</p>
    <v-btn
      block
      append-icon="mdi-arrow-right"
      color="primary"
      @click="handleStartCheckout"
      :disabled="!checkoutFlow.isStepValid(CheckoutFlowStep.WelcomePage)">
      Start check-out
    </v-btn>
  </div>
</template>

<style scoped>
.page {
  background-color: #fcfcfc;
}

.welcome {
  font-size: 20px;
  font-weight: 400;
  line-height: 125%;
  color: #3c3c3c;
}

.title {
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
  color: #1e3036;
}

.instructions {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: #3c3c3c;
}
</style>
